import Menu from "~/components/Menu";

import { XCircleIcon } from "@heroicons/react/20/solid";

export default function ErrorPage({
  message,
  details,
  stack,
}: {
  message: string;
  details: string;
  stack?: string;
}) {
  return (
    <>
      <Menu />
      <main className="min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="rounded-md bg-red-50 p-4">
          <div className="flex">
            <div className="shrink-0">
              <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">{message}</h3>
              <p className="mt-2 text-sm text-red-700">{details}</p>
              {stack && (
                <pre className="w-full p-4 overflow-x-auto text-red-800">
                  <code>{stack}</code>
                </pre>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
